
export class Context {
  private static instance: Context;

  public menu_is_open: boolean | undefined;

  private constructor() {
    //empty private constructor to force the singleton pattern
  }

  public static getInstance(): Context {
    if (!Context.instance) {
      Context.instance = new Context();
    }
    return Context.instance;
  }
}